<template>
  <div class="login-page d-flex flex-column justify-content-center align-items-center" :style="backgroundStyle">
    <div class="overlay" />

    <!-- Title -->
    <div class="system-title mt-3">
      <h1 class="title-gradient">Election System</h1>
    </div>

    <!-- Login Cards -->
    <div class="d-flex flex-row flex-wrap justify-content-center align-items-start gap-4" style="position: relative; z-index: 2;">

      <!-- 🧑 Student Login -->
      <div class="login-box small-card text-center">
        <img src="@/assets/logo.svg" alt="Logo" class="logo mb-3" />
        <h4 class="login-title mb-2">Student Login</h4>
        <p class="subtitle mb-3">Login with your Lamduan Mail account</p>

        <CCol class="text-center">
          <div style="cursor: pointer">
            <img class="zoom" @click="onAuthenGoogle('student')" src="@/assets/icons/logo-google.png" width="50px"/>

          </div>
        </CCol>
        <!-- Error for student -->
        <div class="text-danger my-2" v-if="loginError && selectedLoginSource === 'student'" style="min-height: 30px;">
          {{ loginError }}
        </div>


        <!-- Google Button -->
<!--        <div-->
<!--            class="google-btn-container mb-2"-->
<!--            @click="setSource('student')"-->
<!--            :style="{ pointerEvents: signingIn ? 'none' : 'auto', opacity: signingIn && selectedLoginSource === 'student' ? 0.6 : 1 }"-->
<!--        >-->
<!--          <div id="g-button-student" />-->
<!--        </div>-->
      </div>

      <!-- 🔧 Admin / Committee Login -->
      <div class="login-box small-card text-center">
        <img src="@/assets/logo.svg" alt="Logo" class="logo mb-3" />
        <h4 class="login-title mb-2">Admin / Committee</h4>
        <p class="subtitle mb-3">Login with MFU Google account</p>


        <CCol class="text-center">
          <div style="cursor: pointer">
            <img class="zoom" @click="onAuthenGoogle('admin')" src="@/assets/icons/logo-google.png" width="50px"/>

          </div>
        </CCol>

        <!-- Error for admin -->
        <div class="text-danger my-2" v-if="loginError && selectedLoginSource === 'admin'" style="min-height: 30px;">
          {{ loginError }}
        </div>

        <!-- Google Button -->
<!--        <div-->
<!--            class="google-btn-container mb-2"-->
<!--            @click="setSource('admin')"-->
<!--            :style="{ pointerEvents: signingIn ? 'none' : 'auto', opacity: signingIn && selectedLoginSource === 'admin' ? 0.6 : 1 }"-->
<!--        >-->
<!--          <div id="g-button-admin" />-->
<!--        </div>-->
      </div>

    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import '@/assets/css/login.css';

const G_CLIENT_ID = '225788483142-8pkg8on8nh60ao83ve33ff3lflv2ccvo.apps.googleusercontent.com';

export default {
  name: 'LoginPage',

  data() {
    return {
      selectedLoginSource: null,   // 'student' | 'admin'
      signingIn: false,
      gsiReady: false,
      gsiInitTried: false,
    };
  },

  computed: {
    ...mapState('auth', ['loginError']),
    backgroundStyle() {
      return {
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed',
        minHeight: '100vh',
        position: 'relative',
        overflow: 'hidden',
      };
    },
  },

  methods: {


    async onAuthenGoogle(type) {
      const googleUser = await this.$gAuth.signIn();
      const profile = googleUser.getBasicProfile();
      const id_token = googleUser.getAuthResponse().id_token;
      console.log('User:', profile);
      console.log('googleUser', googleUser)

      // var body = {}
      // body.token = id_token
      // this.$store.dispatch("auth/singin", body)

      await this.signInWithGoogle({ token : id_token, loginSource: type });


    },


    ...mapActions('auth', ['signInWithGoogle']),

    setSource(src) {
      if (this.selectedLoginSource !== src) {
        this.$store.commit('auth/SET_LOGIN_ERROR', '');
      }
      this.selectedLoginSource = src;
    },

    async onGoogleResponse(response) {
      const token = response?.credential;
      console.log(token)


      if (!token) return console.error('No Google credential returned.');
      if (!this.selectedLoginSource) {
        // ป้องกันกรณีผู้ใช้กดปุ่มเร็วมาก จน click wrapper ยังไม่เซ็ต source
        this.$store.commit('auth/SET_LOGIN_ERROR', 'Please choose a login type.');
        return;
      }
      try {
        this.signingIn = true;
        await this.signInWithGoogle({ token, loginSource: this.selectedLoginSource });
      } finally {
        this.signingIn = false;
      }
    },

    initGSI() {
      if (this.gsiInitTried) return;
      this.gsiInitTried = true;

      if (window.google?.accounts?.id) {
        window.google.accounts.id.initialize({
          client_id: G_CLIENT_ID,
          callback: this.onGoogleResponse,
          // ux_mode: 'popup', // หรือ 'redirect' ถ้าต้องการ
        });

        window.google.accounts.id.renderButton(
            document.getElementById('g-button-student'),
            { theme: 'outline', size: 'large', width: '100%' }
        );
        window.google.accounts.id.renderButton(
            document.getElementById('g-button-admin'),
            { theme: 'outline', size: 'large', width: '100%' }
        );

        this.gsiReady = true;
      } else {
        // รีทรายโหลดช้า
        setTimeout(() => { this.gsiInitTried = false; this.initGSI(); }, 600);
      }
    },
  },
  mounted() {
    this.initGSI();
  },
};
</script>
